import 'lazysizes';

$(document).ready(function () {
  if ("devicePixelRatio" in window && window.devicePixelRatio == 2) {
    var img_to_replace = $("img.replace-2x").get();

    for (var i = 0, l = img_to_replace.length; i < l; i++) {
      var src = img_to_replace[i].src;
      src = src.replace(/\.(png|jpg|gif)+$/i, "@2x.$1");
      img_to_replace[i].src = src;
    }
  }

  $(document).on("click", "[data-toggle=favorite]", function (event) {
    event.preventDefault();
    const id = $(this).data("id");
    axios.post(`/favorites/${id}`).then((response) => {
      if (response.data.result === "added") {
        $(this).addClass("in");
      } else {
        $(this).removeClass("in");
      }
    });
  });

  $(".mobile-menu").removeClass("active");
  $(".header__main").removeClass("z-1000");

  $(".mobile-menu-button").click(function () {
    $(".header__main").addClass("z-1000");
    var mobmenu = $(this).attr("data-target");
    $(mobmenu).addClass("active");
  });

  $(".mobile-menu").click(function () {
    $(".mobile-menu").removeClass("active");
    setTimeout(function () {
      $(".header__main").removeClass("z-1000");
    }, 300);
  });

  $(".mobile-user-menu").removeClass("active");

  $(".auth__user").click(function () {
    $(".header__main").addClass("z-1000");
    var usrmenu = $(this).attr("data-target");
    $(usrmenu).addClass("active");
    // return false;
  });

  $(".mobile-user-menu").click(function () {
    $(".mobile-user-menu").removeClass("active");
    setTimeout(function () {
      $(".header__main").removeClass("z-1000");
    }, 300);
  });

  $("#catalog-filter").removeClass("active");

  $(".filter-btn").click(function () {
    $("#catalog-filter").addClass("active");
    // return false;
  });

  $("#catalog-filter .close").click(function () {
    $("#catalog-filter").removeClass("active");
  });

  $(".footer .mobile-menu-button").click(function () {
    $(".header__main").removeClass("z-1000");
    $(".footer").addClass("z-1000");
  });
  $(".footer .mobile-menu").click(function () {
    setTimeout(function () {
      $(".footer").removeClass("z-1000");
    }, 1000);
  });

  $(".collapse")
    .on("shown.bs.collapse", function () {
      $(this)
        .parent()
        .find(".fa-plus")
        .removeClass("fa-plus")
        .addClass("fa-minus");
    })
    .on("hidden.bs.collapse", function () {
      $(this)
        .parent()
        .find(".fa-minus")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    });

  (function () {
    var windowSize = $(window).width(); // Could've done $(this).width()

    if (!$("header").hasClass("sticky_header")) return;

    if (windowSize >= 768) {
      $(window).scroll(function () {
        var sticky = $(".header__main"),
          scroll = $(window).scrollTop(),
          headerHeight = $(".header__helper");
        if (scroll >= 15) {
          sticky.addClass("fixed");
          // headerHeight.css('min-height', '100px');
          $(".header .header__sticky .row.bottom-border").hide();
          $(".header__main").css({
            background:
              "linear-gradient(to right, #354672 0%, #394f7e 12%, #394f7e 12%, #3d659d 57%, #4174b4 100%)",
            "z-index": "100",
          });
        } else {
          sticky.removeClass("fixed");
          // headerHeight.css('min-height', '202px');
          $(".header .header__sticky .row.bottom-border").show();
          $(".header__main").css({ background: "unset", "z-index": "13" });
        }
      });
    }
  })();

  if ($(window).width() < 767) {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 100) {
        $(".header__sticky").addClass("sticky-scrolled");
        $(".header__main").addClass("z-1000");
      } else {
        $(".header__sticky").removeClass("sticky-scrolled");
        $(".header__main").removeClass("z-1000");
      }
    });
  }
});
